// Соединение берём общее, через initializeDB: сырой openDB(DB_NAME, DB_VERSION)
// заводил на каждый вызов отдельное соединение и никогда его не закрывал.
// Пока версия БД не менялась, это просто копило коннекты; при смене версии
// апгрейд вставал намертво, ожидая их закрытия, и приложение зависало.
import { initializeDB } from '../config/db';
import { MEGGER_TEST_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const meggerTestService = {
    /**
     * Submit megger test to server
     */
    async submit(test) {
        try {
            const response = await axiosInstance.post('/megger-test/submit', test);
            return response.data;
        } catch (error) {
            console.error('Error submitting megger test:', error);
            throw error;
        }
    },

    /**
     * Save megger test as draft in IndexedDB
     */
    async saveDraft(test) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const testToSave = {
            ...test,
            updatedAt: now
        };

        // Only set status to draft if not already set
        if (!testToSave.status) {
            testToSave.status = 'draft';
        }

        if (!testToSave.createdAt) {
            testToSave.createdAt = now;
        }

        await db.put(MEGGER_TEST_STORE, testToSave);
        return testToSave;
    },

    /**
     * Load megger test by UUID from IndexedDB
     */
    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(MEGGER_TEST_STORE, uuid);
    },

    /**
     * Get all megger tests from IndexedDB
     */
    async getAll() {
        const db = await initializeDB();
        return await db.getAll(MEGGER_TEST_STORE);
    },

    /**
     * Delete megger test from IndexedDB
     */
    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(MEGGER_TEST_STORE, uuid);
    }
};

export default meggerTestService;
